import axios from "axios";
import _ from "lodash";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAlertContext } from "../Context/KYCApplicationContext/AlertContext/AlertContext";
import { useLoader } from "../Context/KYCApplicationContext/LoaderContext/LoaderContext";
import { OK } from "../Utils/GlobalValues";
import { SessionKeyEnum } from "./../Enumeration/SessionKeyEnum";

const serverBaseURL = `/api/internal/`;

export const getAPI = () => {
  return serverBaseURL;
};

const API = axios.create({
  baseURL: serverBaseURL,
});
let isRedirecting = false;
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.clear();
      if (!isRedirecting) {
        isRedirecting = true;

        const customError = new Error("Unauthorized");
        customError.isUnauthorized = true;

        return Promise.reject(customError);
      }

      return new Promise(() => {});
    }
    return Promise.reject(error);
  },
);
export const useResource = () => {
  const [response, setResponse] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); //different!
  const [controller, setController] = useState();
  const { showAlert } = useAlertContext();
  const { showLoader, hideLoader } = useLoader();
  /* replace the path variable with params value and constract request parameters also*/
  const getRequestUrl = (url, params) => {
    if (!params) {
      //added some time stamp for differentiate the request
      return url + "?t=" + Date.now();
    } else {
      let urlPathArray = _.split(url, "/");
      urlPathArray.forEach((urlPath, index, newPathArray) => {
        //path variable name start with ":"
        if (urlPath.charAt(0) === ":") {
          let propertyName = urlPath.replace(":", "");
          let value = _.get(params, propertyName);
          if (value != null) {
            //update the path variable value
            newPathArray[index] = value;
            //remove the element for params
            _.unset(params, propertyName);
          }
        }
      });
      //join the url path form the new url
      let newUrl = _.join(urlPathArray, "/");
      newUrl = newUrl + getRequestParams(params);
      return newUrl;
    }
  };

  /**
   * get the request params for the give object
   * @param {object} params
   * @returns String
   */
  const getRequestParams = (params) => {
    //no param exists the retrun empty.
    //if(!params) return ";"

    //added some time stamp for differentiate the request
    var requestParamString = "?t=" + Date.now() + "&";

    //loop the prams and create the request param
    if (params) {
      _.forOwn(params, (value, key) => {
        requestParamString = requestParamString + key + "=" + value + "&";
      });
    }

    return requestParamString.slice(0, -1);
  };

  const getRequestConfig = (contentType) => {
    let sessionId = sessionStorage.getItem(SessionKeyEnum.AppKey);
    let Id = sessionStorage.getItem(SessionKeyEnum.Id);
    let applicationId = sessionStorage.getItem(SessionKeyEnum.KycApplicationId);
    const requestConfig = {
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
      },
    };

    if (contentType) {
      requestConfig.headers.ContentType = contentType;
    }

    if (sessionId) {
      requestConfig.headers.token = sessionId;
    }

    if (sessionId) {
      requestConfig.headers.Authorization = `Bearer ${sessionId}`;
    }

    if (Id) {
      requestConfig.headers.Id = Id;
    }

    if (applicationId) {
      requestConfig.headers.applicationId = applicationId;
    }

    return requestConfig;
  };
  const getData = (config) => {
    const { url, params } = config;
    let requestUrl = getRequestUrl(url, params);

    let fetchPromise = new Promise(function (onSuccess, onError) {
      try {
        setLoading(true);
        const ctrl = new AbortController();
        setController(ctrl);

        API.get(requestUrl, getRequestConfig())
          .then((res) => {
            //console.log(res);
            setResponse(res.data);
            onSuccess(res.data);
          })
          .catch((error) => {
            // toast.error(error.message);
            //console.log(error.message);
            showErrorMessage(error);
            setError(error.message);
            if (error?.isUnauthorized) return;
            onError(error);
          });
      } catch (err) {
        //console.log(err.message);
        showErrorMessage(err);
        setError(err.message);
        if (error?.isUnauthorized) return;
        onError(err);
      } finally {
        setLoading(false);
      }
    });
    return fetchPromise;
  };

  const postData = (
    config,
    suppressErrorHandle = false,
    suppressSuccessToast = false,
  ) => {
    const { url, params, data } = config;
    let requestUrl = getRequestUrl(url, params);

    let fetchPromise = new Promise(function (onSuccess, onError) {
      try {
        setLoading(true);
        const ctrl = new AbortController();
        setController(ctrl);

        API.post(
          requestUrl,
          {
            ...data,
            signal: ctrl.signal,
          },
          getRequestConfig(),
        )
          .then((res) => {
            if (suppressSuccessToast != null && suppressSuccessToast == true) {
              // do nothing
            } else {
              showSuccessMessage(res);
            }

            //console.log(res);
            setResponse(res.data);
            onSuccess(res.data);
          })
          .catch((error) => {
            if (!suppressErrorHandle) {
              showErrorMessage(error);
            }
            setError(error.message);
            if (error?.isUnauthorized) return;
            onError(error);
          });
      } catch (err) {
        if (!suppressErrorHandle) {
          showErrorMessage(err);
        }
        setError(err.message);
        onError(err);
        if (error?.isUnauthorized) return;
      } finally {
        setLoading(false);
      }
    });
    return fetchPromise;
  };

  const uploadData = (config, suppressSuccessToast) => {
    const { url, params, fileToUpload } = config;
    let requestUrl = getRequestUrl(url, params);
    const formData = new FormData();
    formData.append("filesList", fileToUpload);
    const requestConfig = getRequestConfig("multipart/form-data");

    let uploadPromise = new Promise(function (onSuccess, onError) {
      try {
        setLoading(true);
        const ctrl = new AbortController();
        setController(ctrl);

        API.post(requestUrl, formData, requestConfig)
          .then((res) => {
            if (!suppressSuccessToast) {
              toast.success("File uploaded successfully");
            }
            //console.log(res);
            setResponse(res.data);
            onSuccess(res.data);
          })
          .catch((error) => {
            showErrorMessage(error);
            setError(error.message);
            if (error?.isUnauthorized) return;
            onError(error);
          });
      } catch (err) {
        showErrorMessage(err);
        setError(err.message);
        if (error?.isUnauthorized) return;
        onError(err);
      } finally {
        setLoading(false);
      }
    });
    return uploadPromise;
  };
  const uploadDataWithoutAlertmsg = (config) => {
    return uploadData(config, true);
  };

  const showSuccessMessage = function (response) {
    if (response && response.headers && response.headers["x-kycapp-alert"]) {
      toast.success(response.headers["x-kycapp-alert"]);
    } else {
      //toast.success("Success");
    }
  };

  const showErrorMessage = function (error) {
    if (error != null && error.isUnauthorized) {
      sessionStorage.clear();
      showAlert(
        "Alert",
        OK,
        "Session has expired. You will be redirected to Login Page.",
        () => {
          showLoader();
          getConfig()
            .then((res) => {
              if (res) {
                isRedirecting = false;
                window.location.replace(res?.rd_resume_popup);
              } else {
                hideLoader();
              }
            })
            .catch(() => {
              hideLoader();
            });
        },
      );
      return;
    }
    if (
      error &&
      error.response &&
      error.response.headers &&
      error.response.headers["x-kycapp-error"]
    ) {
      toast.error(error.response.headers["x-kycapp-error"], {
        autoClose:
          error.response.headers["x-kycapp-error"].length > 50 ? 8000 : 3000,
      });
    } else if (
      error.response != null &&
      error.response.data != null &&
      error.response.data.message != null
    ) {
      toast.error(error.response.data.message, {
        autoClose: error.response.data.message.length > 50 ? 8000 : 3000,
      });
    } else if (error != null && error.message != null) {
      toast(error.message, {
        autoClose: error.message.length > 50 ? 8000 : 3000,
      });
    }
  };

  const getConfig = () => {
    return getData({ url: "/public/kyc-settings-pre-login" });
  };

  useEffect(() => {
    //console.log(controller)

    // useEffect cleanup function
    return () => controller && controller.abort();
  }, [controller]);

  return [
    error,
    loading,
    getData,
    postData,
    uploadData,
    uploadDataWithoutAlertmsg,
    getConfig,
  ];
};
